var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseBold = function SvgCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.396 19.593c-.534-.521-.522-1.44 0-1.95l7.637-7.648L.396 2.358c-.522-.51-.534-1.416 0-1.962.534-.534 1.44-.522 1.962 0l7.637 7.637L17.63.396a1.414 1.414 0 0 1 1.962.012c.547.522.534 1.428.013 1.95l-7.637 7.637 7.637 7.649c.521.521.521 1.415-.013 1.95-.534.546-1.428.533-1.962.012l-7.636-7.637-7.637 7.637c-.522.521-1.416.521-1.962-.013"
  })));
};
export default SvgCloseBold;